import React, { useEffect } from "react";

const AdSense = () =>
  //  { adSlot, style }
  {
    useEffect(() => {
      try {
        // Push the ad only if window.adsbygoogle exists
        if (window.adsbygoogle) {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      } catch (error) {
        console.error("Error loading AdSense ad:", error);
      }
    }, []);

    return <></>;
    /*   return (
    <ins
      className="adsbygoogle"
      style={style || { display: "block" }}
      data-ad-client="ca-pub-6635656507329355"
      data-ad-slot={adSlot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  ); */
  };

export default AdSense;
